import { Compass, UtensilsCrossed, Camera, Coffee, Zap, Moon, ShoppingBag, Mountain } from 'lucide-react';

// Color palette per personality — used as card background.
// Each pair has a strong color and a light tint for accents.
export const PERSONALITIES = {
    'The Explorer':            { color: '#E07A5F', tint: '#FCEEE7', icon: Compass,         emoji: '🧭' },
    'The Foodie':              { color: '#D4A373', tint: '#FAEFE2', icon: UtensilsCrossed, emoji: '🍜' },
    'The Photographer':        { color: '#7CA5B8', tint: '#E9F1F5', icon: Camera,          emoji: '📷' },
    'The Relaxed Wanderer':    { color: '#4A7C59', tint: '#E8F2EC', icon: Coffee,          emoji: '🧘' },
    'The Efficiency Maximiser':{ color: '#1D2D44', tint: '#E0E4EB', icon: Zap,             emoji: '⚡' },
    'The Night Owl':           { color: '#6D597A', tint: '#EDE7F0', icon: Moon,            emoji: '🌙' },
    'The Shopaholic':          { color: '#B5838D', tint: '#F4E7E9', icon: ShoppingBag,     emoji: '🛍️' },
    'The Adventurer':          { color: '#B86B3B', tint: '#F6E8DC', icon: Mountain,        emoji: '🏔️' },
};

export function personalityMeta(name) {
    return PERSONALITIES[name] || { color: '#8A8175', tint: '#F4F0EA', icon: Compass, emoji: '✨' };
}

export const VOTE_META = {
    must: { label: 'Must-have', color: '#4A7C59', tint: 'rgba(74,124,89,0.10)', score: 3 },
    nice: { label: 'Nice-to-have', color: '#C77B3A', tint: 'rgba(199,123,58,0.10)', score: 1 },
    skip: { label: 'Skip', color: '#8A8175', tint: 'rgba(138,129,117,0.10)', score: 0 },
};
